import { LOCATION_CHANGE, push } from 'connected-react-router';
import { match } from '../../../shared/utils/match';
import { createMiddleware } from '../../../shared/redux';
import { ROUTES } from '../auth.constants';
import { requestConfirmInvite } from '../confirm-invite/confirm-invite-state';
import { requestCreateProfile, requestUserStatus } from '../create-profile/create-profile-state';
import {
    getSignInFlags,
    getUserName,
    getUserPhoneNumber,
    isNewUser, signInFederated,
} from '../sign-in/sign-in.state';
import { REDIRECT_TO_SPLASH_SCREEN } from './splash-screen-state';
import { requestCheckSignUpData } from '../check-sign-up-data/check-sign-up-data.state';

export const splashScreenMiddleware = createMiddleware({
    [LOCATION_CHANGE]: match((_, action) => action.payload.location.pathname, {
        [ROUTES.SPLASH_SCREEN]: (state, action) => {
            const error = action.payload.location?.state?.error;
            const { fromSignUp, fromInvite, loadingFederatedLogin } = getSignInFlags(state);

            if (loadingFederatedLogin) {
                return signInFederated();
            }
            if (error === 'USER_SIGN_UP_PENDING') {
                return requestUserStatus();
            }
            if (fromSignUp) {
                return requestCreateProfile();
            }
            if (fromInvite) {
                const newUser = isNewUser(state);
                const fullName = getUserName(state);
                const phone = getUserPhoneNumber(state);

                return requestConfirmInvite({
                    newUser,
                    fullName,
                    phone,
                });
            }
            return requestCheckSignUpData();
        },
    }),
    [REDIRECT_TO_SPLASH_SCREEN]: () => push(ROUTES.SPLASH_SCREEN),
});
